import React, { useState } from 'react';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { Link } from 'react-router-dom';

const overview = [
  {
    title: "About Pest and Weed Control",
    content: [
      {
        label: "Lecture Overview: Importance of Pest Management",
        time: "01:45"
      },
      {
        label: "Lecture: Common Weed Types",
        time: "02:30"
      }
    ]
  }
];

const accordionData = [
  {
    title: "Is Pest and Weed Control right for me?",
    content: [
      {
        label: "Lecture1.1 Introduction to the User Experience Course",
        time: "02:53"
      },
      {
        label: "Lecture1.2 Exercise: Your first design challenge",
        time: "02:53"
      },
      {
        label: "Lecture1.3 How to solve the previous exercise",
        time: "02:53"
      },
      {
        label: "Lecture1.4 Find out why smart objects are amazing",
        time: "02:53"
      },
      {
        label: "Lecture1.5 How to use text layers effectively",
        time: "02:53"
      }
    ]
  },
  {
    title: "Pest and Weed Control study options and costs",
    content: [
      {
        label: "Lecture2.1 Overview of Costs",
        time: "03:10"
      },
      {
        label: "Lecture2.2 Scholarships and Assistance",
        time: "02:40"
      }
    ]
  },
  {
    title: "Wireframing Low Fidelity",
    content: [
      {
        label: "Lecture3.1 Basics of Wireframing",
        time: "01:53"
      },
      {
        label: "Lecture3.2 Best Practices",
        time: "02:33"
      }
    ]
  },
  {
    title: "Type, Color & Icon Introduction",
    content: [
      {
        label: "Lecture4.1 Typography Essentials",
        time: "01:20"
      },
      {
        label: "Lecture4.2 Working with Color",
        time: "02:00"
      }
    ]
  }
];

interface BannerProps {
  apiValues: any;
}



const TailwindAccordion: React.FC<BannerProps> = ({ apiValues }) => {

  const [overviewOpenIdx, setOverviewOpenIdx] = useState<number | null>(null);
  const [accordionOpenIdx, setAccordionOpenIdx] = useState<number | null>(null);

  const toggleOverview = (idx: number) => {
    setOverviewOpenIdx(overviewOpenIdx === idx ? null : idx);
  };

  const toggleAccordion = (idx: number) => {
    setAccordionOpenIdx(accordionOpenIdx === idx ? null : idx);
  };

  return (
    <div className="mx-auto">
      <h3 className="mb-3 text-xl font-bold">
        {apiValues?.collapseTitle || "Subject Overview"}
      </h3>

      {/* {overview.map((section, idx) => (
        <div key={idx} className="mb-3 border border-gray-300 rounded-lg shadow-sm bg-gray-50">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-lg font-semibold text-left focus:outline-none hover:bg-gray-100"
            onClick={() => toggleOverview(idx)}
          >
            <span>{section.title}</span>
            <svg
              className={`w-5 h-5 transform transition-transform duration-200 ${overviewOpenIdx === idx ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${overviewOpenIdx === idx ? 'max-h-96' : 'max-h-0'}`}
          >
            <ul className="divide-y divide-gray-100">
              {section.content.map((item, i) => (
                <li key={i} className="flex justify-between items-center px-5 py-3">
                  <p className="flex items-center mb-0">
                    <ImageWithBasePath className="me-2 w-5 h-5" src="./assets/img/icons/play.svg" alt="icon" />
                    {item.label}
                  </p>
                  <div className="flex gap-4">
                    <Link to="#" className="text-blue-600 hover:underline text-sm">Preview</Link>
                    <span className="text-gray-500 text-sm">{item.time}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))} */}


      {
        (Array.isArray(apiValues?.collapseArray) ? apiValues?.collapseArray : []).map((item: any, index: number) => {

          return (

            // {
            //   accordionData.map((section, idx) => (
            <div key={index} className="mb-3 border border-gray-200 rounded-lg shadow-sm bg-gray-50">
              <button
                className="w-full flex justify-between items-center px-5 py-4 text-lg font-semibold text-left focus:outline-none hover:bg-gray-100"
                onClick={() => toggleAccordion(index)}
              >
                <span>
                  {item.title || "Accordion Title"}
                </span>
                <svg
                  className={`w-5 h-5 transform transition-transform duration-200 ${accordionOpenIdx === index ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${accordionOpenIdx === index ? 'max-h-96' : 'max-h-0'}`}
              >
                {/* <ul className="divide-y divide-gray-100 bg-white"> */}


                <div className="flex justify-between items-center px-5 py-3 bg-white">
                  <p className="flex items-center mb-0">
                    {/* <ImageWithBasePath className="me-2 w-5 h-5" src="./assets/img/icons/play.svg" alt="icon" /> */}
                    {item.description || "Default Description"}
                  </p>

                  {/* <div className="flex gap-4">
                    <Link to="#" className="text-blue-600 hover:underline text-sm">Preview</Link>
                    <span className="text-gray-500 text-sm">{item.time}</span>
                  </div> */}
                </div>
                  
                {/* </ul> */}
                
              </div>
            </div>
          )
        }) || []
      }
    </div >
  );
};

export default TailwindAccordion;
